"use client"

import { useState } from "react"
import { MdModeEditOutline, MdDelete } from "react-icons/md"
import AdminEditProduct from "./AdminEditProduct"
import { toast } from "react-toastify"
import summaryApi from "../common/index"


const AdminProductCard = ({ data, fetchData }) => {
  const [editProduct, setEditProduct] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

    const handleDelete = async () => {
    try {
      const response = await fetch(`${summaryApi.deleteProduct.url}/${data._id}`, {
        method: summaryApi.deleteProduct.method,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();

      if (result.success) {
        toast.success("Product deleted successfully", {
          position: 'top-center',
          autoClose: 3000,
          style: {
            background: 'linear-gradient(to right, #4a90e2, #9013fe)',
            color: '#fff',
          },
        });
        fetchData();
      } else {
        toast.error(`Failed to delete product: ${result.message}`, {
          style: {
            background: 'linear-gradient(to right, #e94e77, #ff6b6b)',
            color: 'white'
          }
        });
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("Error deleting product", {
        style: {
          background: 'linear-gradient(to right, #e94e77, #ff6b6b)',
          color: 'white'
        }
      });
    }
    setShowConfirmDialog(false); // Close dialog after action
  };
const totalStock = data.packagingOptions?.length
  ? data.packagingOptions.reduce((total, option) => total + (option.stock ?? 0), 0)
  : 0;
  const primaryImage = data.productImages?.find((img) => img.isPrimary) || data.productImages?.[0]
  const displayImage = primaryImage?.url || data.productImage?.[0] || "/placeholder.svg?height=128&width=128"

  return (
    <div className="bg-white p-4 rounded-lg shadow-md relative flex flex-col w-48 group hover:shadow-lg transition-shadow">
      <div className="absolute top-2 left-2 bg-orange-500 text-white text-xs font-semibold px-2 py-1 rounded-full">
        {data.section || data.category || "General"}
      </div>

      <div className="flex-grow">
        <div className="w-full h-32 flex justify-center items-center mx-auto mb-3">
          <img
            src={displayImage || "/placeholder.svg"}
            className="object-cover h-full w-full rounded"
            alt={data.productName || "Product"}
          />
        </div>
        <h1 className="line-clamp-2 break-words font-medium text-sm">{data.productName || "Unnamed Product"}</h1>
        <div className="mt-2">
          <p className="font-semibold text-orange-600">£ {data.priceRs || data.sellingPrice || "0"}</p>
          {data.compareAtPriceRs && <p className="text-xs text-gray-500 line-through">£ {data.compareAtPriceRs}</p>}
        </div>
        <p className="text-xs text-gray-600 mt-1">{data.brandName || "No Brand"}</p>

        <div className="mt-2 text-xs text-gray-500">
        <p>
  Category: {data.category === "other" ? data.customCategory : data.category || "Not set"}
</p>

<p>Stock: {totalStock}</p>


        </div>
      </div>

      <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-30 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer rounded-lg">
        <div
          className="p-3 bg-white rounded-full shadow-md mx-2 hover:bg-gray-50 transition-colors"
          onClick={() => setEditProduct(true)}
        >
          <MdModeEditOutline size={20} className="text-orange-500" />
        </div>

        <div
          className="p-3 bg-white rounded-full shadow-md mx-2 hover:bg-gray-50 transition-colors"
          onClick={() => setShowConfirmDialog(true)}
        >
          <MdDelete size={20} className="text-red-500" />
        </div>
      </div>

      {editProduct && (
        <AdminEditProduct productData={data} onClose={() => setEditProduct(false)} fetchData={fetchData} />
      )}

      {showConfirmDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl">
            <h3 className="text-lg font-semibold mb-4">Confirm Delete</h3>
            <p className="text-gray-600 mb-6">Are you sure you want to delete this product?</p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => setShowConfirmDialog(false)}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default AdminProductCard
